//#region Helper Imports

import { DataProvider, ConvertHelper } from "../helpers"

//#endregion

//#region Model Imports

import { Enums } from "../models/common/enums"
import { MeasureCollection, ColumnInfo } from "../models/custom"
import { OpFile } from "../models/core"

//#endregion

import { DataProviderRequest } from "./utils"

export class DataProviderMeasurements {

    //#region Ctor

    public constructor(private dataProvider: DataProvider) { }

    //#endregion

    //#region Export

    public exportMeasurements(
        measurementViewStyle: Enums.MeasurementViewStyle,
        columns: ColumnInfo[],
        dateFrom: Date,
        dateTo: Date,
        idLocation: ReadonlyArray<number> = null,
        serialNbr: ReadonlyArray<number> = null,
        idMeter: ReadonlyArray<number> = null,
        idDataType: ReadonlyArray<number> = null
    ): DataProviderRequest<OpFile> {
        const promise = this.dataProvider
            .sendRequestWithSession('OpxExportMeasurement', {
                MeasurementViewStyle: measurementViewStyle,
                Columns: columns,
                IdLocation: idLocation,
                SerialNbr: serialNbr,
                IdMeter: idMeter,
                IdDataType: idDataType,
                Time: ConvertHelper.dateRangeToTypeDateTimeCode(dateFrom, dateTo),
                topCount: null,
                customWhereClause: null,
                commandTimeout: 0
            }, 'OpxExportMeasurementResult')
            .then((response: any) => {
                if (response != null) {
                    return new OpFile(response)
                }

                return null
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    //#endregion

    //#region Get

    public getLatestMeasurementsFilter(idLocation: ReadonlyArray<number>, serialNbr: ReadonlyArray<number>, idMeter: ReadonlyArray<number>, idDataType: ReadonlyArray<number>): DataProviderRequest<MeasureCollection[]> {
        const promise = this.dataProvider
            .sendRequestWithSession('OpxLatestMeasurementFilter', { IdLocation: idLocation, SerialNbr: serialNbr, IdMeter: idMeter, IdDataType: idDataType, topCount: null, customWhereClause: null, commandTimeout: 0 }, 'OpxLatestMeasurementFilterResult')
            .then((result: any[]) => {
                return result.map(r => new MeasureCollection(r))
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    public getMeasurementsFilter(idLocation: ReadonlyArray<number>, serialNbr: ReadonlyArray<number>, idMeter: ReadonlyArray<number>, idDataType: ReadonlyArray<number>, dateFrom: Date, dateTo: Date): DataProviderRequest<MeasureCollection[]> {
        const promise = this.dataProvider
            .sendRequestWithSession('OpxMeasurementFilter', {
                IdLocation: idLocation,
                SerialNbr: serialNbr,
                IdMeter: idMeter,
                IdDataType: idDataType,
                Time: ConvertHelper.dateRangeToTypeDateTimeCode(dateFrom, dateTo),
                topCount: null,
                customWhereClause: null,
                commandTimeout: 0
            }, 'OpxMeasurementFilterResult')
            .then((result: any[]) => {
                return result.map(r => new MeasureCollection(r))
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    //#endregion
}